import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userApi, type AddUserRequest } from "@repo/api";
import { userQueryKeys } from "../../../pages/IspmUsers/queryKeys";
import { Logger } from "@saviynt/common";

export const useCreateUser = () => {
  const queryClient = useQueryClient();

  const { mutate, isError, isSuccess, isPending } = useMutation({
    mutationFn: (payload: AddUserRequest) => userApi.createUser(payload),
    onError: (error) => {
      Logger.error("Error creating user:", error);
    },
    onSuccess: (data) => {
      Logger.log("Successfully created user:", data);
      void queryClient.invalidateQueries({ queryKey: userQueryKeys.lists() });
    },
  });

  return { mutate, isError, isSuccess, isPending };
};
